export default __webpack_public_path__ + "static/media/up-square.97c83da1.svg";